"use client";

import { UseFormReturn } from "react-hook-form";
import FormFields from "../Fields";
import Buttons from "@/components/core/Buttons";
import { UpdateAiConfigurationData } from "@/components/shared/Forms/UpdateAiConfigurationForm/schema";
import { ITool } from "@/actions/ai-configuration/tool/types";
import { ToolSchema } from "@/components/shared/Forms/CreateAiConfigurationForm/schema";

interface ICreateToolFormProps {
  form: UseFormReturn<UpdateAiConfigurationData>;
  index: number;
  onSave: (tool: ITool, index: number) => void;
  onClose: () => void;
}

const CreateToolForm = ({
  onSave,
  onClose,
  form,
  index,
}: ICreateToolFormProps) => {
  const onSubmit = () => {
    const tool = form.getValues(`tools.${index}`);

    const parsed = ToolSchema.safeParse(tool);

    form.clearErrors();

    if (!parsed.success) {
      parsed.error.errors.forEach((err) => {
        form.setError(`tools.${index}.${err.path[0]}` as any, {
          message: err.message,
        });
      });
      return;
    }

    onSave(parsed.data, index);
    onClose();
  };

  return (
    <>
      <div className="w-full flex flex-col items-center gap-y-6">
        <FormFields.InputFormField
          form={form}
          formName={`tools.${index}.name`}
          label="Nome"
        />

        <FormFields.InputFormField
          form={form}
          formName={`tools.${index}.apiUrl`}
          label="URL"
        />

        <FormFields.TextareaFormField
          form={form}
          formName={`tools.${index}.description`}
          label="Descrição"
          rows={6}
        />

        <FormFields.SelectFormField
          form={form}
          formName={`tools.${index}.methodType`}
          label="Método"
          options={[
            { label: "GET", value: "GET" },
            { label: "POST", value: "POST" },
            { label: "PUT", value: "PUT" },
            { label: "DELETE", value: "DELETE" },
            { label: "PATCH", value: "PATCH" },
          ]}
        />

        <FormFields.SelectFormField
          form={form}
          formName={`tools.${index}.type`}
          label="Tipo"
          options={[
            { label: "Cliente", value: "CUSTOMER" },
            { label: "Empresa", value: "COMPANY" },
            { label: "Lista de espera", value: "WAITLIST" },
            { label: "Agendamento", value: "SCHEDULING" },
          ]}
        />

        <Buttons.DefaultButton
          type="button"
          title="Salvar"
          onClick={onSubmit}
        />
      </div>
    </>
  );
};

export default CreateToolForm;
